import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-access-restricted',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './access-restricted.component.html',
  styleUrls: ['./access-restricted.component.scss']
})
export class AccessRestrictedComponent {

}
